import { Loader2 } from "lucide-react";
import { cn } from "../lib/cn";
import { useUiText } from "../lib/locale";

export function Spinner({ className, label }: { className?: string; label?: string }) {
  const text = useUiText();
  return <Loader2 role="status" aria-label={label ?? text.loading} className={cn("size-4 animate-spin", className)} />;
}
